module.exports = __webpack_public_path__ + "static/media/WAV.2107b8ac.svg";